import pluralize from 'pluralize'

const initialState = {
  total: 0,
}

const createMetaReducer =
  (entityName) =>
  (state = initialState, action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          total: action.meta.total,
        }
      default:
        return state
    }
  }

export default createMetaReducer
